"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ganttlab_entities_1 = require("ganttlab-entities");
var helpers_1 = require("../../../sources/gitlab/helpers");
var ViewProjectGitLabStrategy = /** @class */ (function () {
    function ViewProjectGitLabStrategy() {
    }
    ViewProjectGitLabStrategy.prototype.execute = function (source, configuration) {
        return __awaiter(this, void 0, void 0, function () {
            var encodedProject, _a, data, headers, tasksList, _i, data_1, gitlabIssue, task, gitlabPagination;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        encodedProject = encodeURIComponent(configuration.project.path);
                        return [4 /*yield*/, source.safeAxiosRequest({
                                method: 'GET',
                                url: "/projects/" + encodedProject + "/issues",
                                params: {
                                    page: configuration.tasks.page,
                                    // eslint-disable-next-line @typescript-eslint/camelcase
                                    per_page: configuration.tasks.pageSize,
                                    state: 'opened',
                                },
                            })];
                    case 1:
                        _a = _b.sent(), data = _a.data, headers = _a.headers;
                        tasksList = [];
                        for (_i = 0, data_1 = data; _i < data_1.length; _i++) {
                            gitlabIssue = data_1[_i];
                            task = helpers_1.getTaskFromGitLabIssue(gitlabIssue);
                            tasksList.push(task);
                        }
                        tasksList.sort(function (a, b) {
                            if (a.due && b.due) {
                                return a.due.getTime() - b.due.getTime();
                            }
                            return 0;
                        });
                        gitlabPagination = helpers_1.getPaginationFromGitLabHeaders(headers);
                        return [2 /*return*/, new ganttlab_entities_1.PaginatedListOfTasks(tasksList, configuration.tasks.page, configuration.tasks.pageSize, gitlabPagination.previousPage, gitlabPagination.nextPage, gitlabPagination.lastPage, gitlabPagination.total)];
                }
            });
        });
    };
    return ViewProjectGitLabStrategy;
}());
exports.ViewProjectGitLabStrategy = ViewProjectGitLabStrategy;
//# sourceMappingURL=ViewProjectGitLabStrategy.js.map